import React from 'react';
import { DollarOutlined } from '@ant-design/icons';
import SectionCard from '../../common/sectionCard/SectionCard';
import ReviewDetailRow from './ReviewDetailRow';

function ReviewAdvanceDetailsCard({ review }) {
    return (
        <SectionCard icon={<DollarOutlined />} title="Advance Details">
            <ReviewDetailRow
                label="Advance Amount"
                value={`$${review.advance_amount?.toFixed(2) || '0.00'}`}
            />
            <ReviewDetailRow
                label="Fee"
                value={`$${review.fee?.toFixed(2) || '0.00'}`}
            />
            <ReviewDetailRow label="Account Type" value={review.account_type} />
            <ReviewDetailRow label="Confirmation Number" value={review.confirmation_number} />
        </SectionCard>
    );
}

export default ReviewAdvanceDetailsCard;
